import { useParams } from "react-router-dom";
import { LANGS } from "../i18n";

// Returns the active language from the URL (or "en") plus a helper to build
// language-prefixed links. English lives at the root ("/"), others at "/sv" etc.
export function useLocale() {
  const { lang } = useParams();
  const current = LANGS.includes(lang) ? lang : "en";
  const path = (p) => {
    const clean = p.startsWith("/") ? p : `/${p}`;
    return current === "en" ? clean : `/${current}${clean === "/" ? "" : clean}`;
  };
  return { lang: current, path };
}
